/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionData } from './SubscriptionData';
import {
    SubscriptionDataFromJSON,
    SubscriptionDataFromJSONTyped,
    SubscriptionDataToJSON,
    SubscriptionDataToJSONTyped,
} from './SubscriptionData';
import type { BillingAccountData } from './BillingAccountData';
import {
    BillingAccountDataFromJSON,
    BillingAccountDataFromJSONTyped,
    BillingAccountDataToJSON,
    BillingAccountDataToJSONTyped,
} from './BillingAccountData';

/**
 * 
 * @export
 * @interface ProjectData
 */
export interface ProjectData {
    /**
     * 
     * @type {string}
     * @memberof ProjectData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectData
     */
    logoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectData
     */
    currency?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectData
     */
    hasErpIntegration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectData
     */
    hasLeadIntegration?: boolean;
    /**
     * 
     * @type {BillingAccountData}
     * @memberof ProjectData
     */
    billingAccount?: BillingAccountData | null;
    /**
     * 
     * @type {SubscriptionData}
     * @memberof ProjectData
     */
    subscription?: SubscriptionData | null;
}

/**
 * Check if a given object implements the ProjectData interface.
 */
export function instanceOfProjectData(value: object): value is ProjectData {
    return true;
}

export function ProjectDataFromJSON(json: any): ProjectData {
    return ProjectDataFromJSONTyped(json, false);
}

export function ProjectDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'hasErpIntegration': json['hasErpIntegration'] == null ? undefined : json['hasErpIntegration'],
        'hasLeadIntegration': json['hasLeadIntegration'] == null ? undefined : json['hasLeadIntegration'],
        'billingAccount': json['billingAccount'] == null ? undefined : BillingAccountDataFromJSON(json['billingAccount']),
        'subscription': json['subscription'] == null ? undefined : SubscriptionDataFromJSON(json['subscription']),
    };
}

export function ProjectDataToJSON(json: any): ProjectData {
    return ProjectDataToJSONTyped(json, false);
}

export function ProjectDataToJSONTyped(value?: ProjectData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'logoUrl': value['logoUrl'],
        'currency': value['currency'],
        'hasErpIntegration': value['hasErpIntegration'],
        'hasLeadIntegration': value['hasLeadIntegration'],
        'billingAccount': BillingAccountDataToJSON(value['billingAccount']),
        'subscription': SubscriptionDataToJSON(value['subscription']),
    };
}

